export default __webpack_public_path__ + "static/media/apr2023-3.7557583f.jpg";